import React from "react";
import Progressbar from "../CommonComponents/Progressbar";
import TestSvgIcon from "../../Svg/TestSvgIcon";
import Tooltip from "./Tooltip";

const ActivityCard = ({ data }) => {
  // console.log("libtype", data);

  const libTypeMap = {
    2: "MCQ's",
    3: "Descriptive",
    4: "Assignments",
    5: "Coding Challenge",
    11: "SQL",
    12: "Coding Snippet"
  };
  const percentage =
    data.Total_count > 0
      ? Math.round((data.Completed_count / data.Total_count) * 100)
      : 0;
  return (
    <div className="ActivityCard" key={data.libtype}>
      <div className="ActivityCardHead">
        <div className="ActivityCardTitle">
          <TestSvgIcon active={true} disable={true} libType={data.libtype} />
          <Tooltip title={libTypeMap[data.libtype]} placement="bottom" maxChars={15}>
            <p className="ActivityCardLibType">{libTypeMap[data.libtype]}</p>
          </Tooltip>
        </div>
      </div>
      <div className="ActivityCardBody">
        <span>{`${percentage ?? 0}%`}</span>
      </div>
      <div className="ActivivtyCardFooter">
        <Progressbar from={"resume"} percentage={percentage ?? 0} />
      </div>
    </div>
  );
};

export default ActivityCard;
